import classNames from "classnames";
import { setTrackingId } from "client/Misc/utils";
import {
	PropsWithChildren,
	ReactElement
} from "react";
import styles from "./Typography.module.less";

export type TypographyProps = {
	weight?: Weight;
	textColor?: TextColor;
	size?: Size;
	textDecoration?: TextDecoration;
	isItalic?: boolean;
	trackingId?: string;
	title?: string;
};

export const Typography = (props: PropsWithChildren<TypographyProps>): ReactElement => {
	const {
		weight,
		textColor,
		size,
		textDecoration,
		isItalic = false,
		trackingId,
		title,
		children
	} = props;

	return (
		<span
			{...setTrackingId(trackingId)}
			title={title}
			className={classNames(
				weight !== undefined && weightToStyleMap[weight],
				textColor !== undefined && textColorToStyleMap[textColor],
				size !== undefined && sizeToStyleMap[size],
				textDecoration !== undefined && textDecorationToStyleMap[textDecoration],
				isItalic && styles.root_italic
			)}
		>
			{children}
		</span>
	);
};

Typography.displayName = "Typography";

export type Weight = "normal" | "bold";

export type TextColor = "primary" | "secondary" | "tertiary";

export type Size = "body" | "body-small" | "body-extra-small";

export type TextDecoration = "line-through" | "underline" | "none";

const weightToStyleMap: { [key in Weight]: string; } = {
	["normal"]: styles.root_weightNormal,
	["bold"]: styles.root_weightBold
};

const textColorToStyleMap: { [key in TextColor]: string; } = {
	["primary"]: styles.root_textColorPrimary,
	["secondary"]: styles.root_textColorSecondary,
	["tertiary"]: styles.root_textColorTertiary
};

const sizeToStyleMap: { [key in Size]: string; } = {
	["body"]: styles.root_sizeBody,
	["body-small"]: styles.root_sizeBodySmall,
	["body-extra-small"]: styles.root_sizeBodyExtraSmall
};

const textDecorationToStyleMap: { [key in TextDecoration]: string; } = {
	["line-through"]: styles.root_textDecorationLineThrough,
	["underline"]: styles.root_textDecorationUnderline,
	["none"]: styles.root_textDecorationNone
};